<div class="container mb-3 p-0">
    <div class="row g-3 align-items-end p-0">
        @if(filter?.search){
        <div class="col-xl-2 col-lg-3 col-md-4">
            <label class="filter-label">Search</label>
            <span class="p-input-icon-left w-100">
                <i class="pi pi-search small-icon"></i>
                <input pInputText type="text" class="w-100 p-inputtext-sm" placeholder="Search"
                    [formControl]="searchControl" (blur)="onSearchBlur()" />
            </span>
        </div>
        }

        @if(isOrder){
        <div class="col-xl-2 col-lg-3 col-md-4">
            <label class="filter-label">Order</label>
            <input pInputText type="text" class="w-100 p-inputtext-sm" placeholder="Enter Order ID"
                [formControl]="orderControl" />
        </div>
        }

        @if(statusOptions.length){
        <div class="col-xl-2 col-lg-3 col-md-4">
            <label class="filter-label">Status</label>
            <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" placeholder="All"
                styleClass="w-100 p-inputtext-sm" appendTo="body" (onChange)="emitFilters()">
            </p-dropdown>
        </div>
        }

        @if(templateCodeOptions.length){
        <div class="col-xl-2 col-lg-3 col-md-4">
            <label class="filter-label">Template</label>
            <p-dropdown [options]="templateCodeOptions" [(ngModel)]="selectedTemplateCode" placeholder="All"
                styleClass="w-100 p-inputtext-sm" appendTo="body" (onChange)="emitFilters()">
            </p-dropdown>
        </div>
        }

        @if(channelOptions.length){
        <div class="col-xl-2 col-lg-3 col-md-4">
            <label class="filter-label">Channel</label>
            <p-dropdown [options]="channelOptions" [(ngModel)]="selectedChannel" placeholder="All"
                styleClass="w-100 p-inputtext-sm" appendTo="body" (onChange)="emitFilters()">
            </p-dropdown>
        </div>
        }

        @if(planOptions.length){
        <div class="col-xl-2 col-lg-3 col-md-4">
            <label class="filter-label">Plan</label>
            <p-dropdown [options]="planOptions" [(ngModel)]="selectedPlan" placeholder="All"
                styleClass="w-100 p-inputtext-sm" appendTo="body" (onChange)="emitFilters()">
            </p-dropdown>
        </div>
        }
        @if(filter?.dateRange && isDateRange){
        <div class="col-xl-3 col-lg-3 col-md-4">
            <label class="filter-label">Date Range</label>
            <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" dateFormat="dd/mm/yy"
                appendTo="body" styleClass="w-100 p-inputtext-sm" [showIcon]="true" iconDisplay="input"
                (onSelect)="emitFilters()" [maxDate]="maxDate">
            </p-calendar>
        </div>
        }

        @if(filter?.resetButton){
        <div class="col-xl-1 col-lg-2 col-md-3 d-flex">
            <button pButton type="button" label="Reset" icon="pi pi-refresh"
                class="p-button-outlined p-button-secondary p-button-sm"
                style="border-radius: 10px; padding-left: .5rem" (click)="resetFilters()">
            </button>
        </div>
        }
    </div>
    <div class="row mt-2" *ngIf="searchBY">
        <i class="text-muted small">
            <b class="p-button-secondary">Search Applied On:</b> {{ searchBY }}
        </i>
    </div>

</div>